var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content order_period_report" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c("date-range-picker", {
              ref: "picker",
              attrs: {
                startDate: _vm.startDate,
                opens: "right",
                ranges: _vm.ranges,
                "locale-data": _vm.date_locale,
              },
              scopedSlots: _vm._u([
                {
                  key: "input",
                  fn: function (picker) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.printDate(picker.startDate, "DD.MM.YYYY")
                          ) +
                          " - " +
                          _vm._s(_vm.printDate(picker.endDate, "DD.MM.YYYY")) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.dateRange,
                callback: function ($$v) {
                  _vm.dateRange = $$v
                },
                expression: "dateRange",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ml-1", staticStyle: { "min-width": "250px" } },
              [_c("ProjectSelect", { ref: "projectSelect" })],
              1
            ),
            _vm._v(" "),
            _c("LoadingButton", {
              attrs: {
                title: "Показать",
                className: "btn btn-outline-info ml-1",
                onClick: _vm.showStatistics,
                loading: _vm.loading,
                color: _vm.$constants.LOADING_COLOR,
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading && _vm.ordersData
            ? _c(
                "div",
                [
                  !_vm.ordersData
                    ? [_c("p", [_vm._v("Нет данных")])]
                    : [
                        _c("div", { staticClass: "flex" }, [
                          _c("div", { staticClass: "order_data_block" }, [
                            _c("p", [
                              _vm._v("Заявок поступило: "),
                              _c(
                                "strong",
                                {
                                  class: {
                                    "badge-primary":
                                      _vm.typeFilter !== "closed",
                                    "badge-dark": _vm.typeFilter === "closed",
                                    "badge pointer": true,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateDrugs("incomes")
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.ordersData.total))]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v("В работе: "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.ordersData.in_progress)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v("Отменены: "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.ordersData.rejected)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v("Закрыты: "),
                              _c(
                                "strong",
                                {
                                  class: {
                                    "badge-primary":
                                      _vm.typeFilter === "closed",
                                    "badge-dark": _vm.typeFilter !== "closed",
                                    "badge pointer": true,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateDrugs("closed")
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.ordersData.closed))]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "chart_block" },
                            [
                              _c("highcharts", {
                                attrs: { options: _vm.chartData },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "table-component",
                              {
                                attrs: {
                                  data: _vm.tableData,
                                  "filter-placeholder": "Поиск препарата",
                                  "sort-by": "title",
                                  small: true,
                                  "head-variant": "light",
                                  "sort-order": "asc",
                                  "table-class":
                                    "table table-hover table-sm mt-1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "tfoot",
                                      fn: function ({ rows }) {
                                        return [
                                          _c("tr", { staticClass: "footer" }, [
                                            _c(
                                              "th",
                                              {
                                                staticClass: "text-right",
                                                attrs: { colspan: "3" },
                                              },
                                              [
                                                _vm._v("Всего препаратов: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(_vm.tableData.length)
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("th", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    Math.round(
                                                      _vm.totalData.soldQty * 10
                                                    ) / 10
                                                  )
                                                ),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("th", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    Math.round(
                                                      _vm.totalData.sum * 10
                                                    ) / 10
                                                  )
                                                ),
                                              ]),
                                            ]),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2084074186
                                ),
                              },
                              [
                                _c("table-column", {
                                  attrs: { sortable: false, label: "#" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (row) {
                                          return [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(row.index + 1) +
                                                "\n                "
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3156360189
                                  ),
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    sortable: false,
                                    label: "ID",
                                    show: "drug.id",
                                  },
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    sortable: true,
                                    label: "Перпарат",
                                    type: "string",
                                    show: "drug.title",
                                  },
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    sortable: true,
                                    label: "Количество",
                                    show: "soldData.totalQty",
                                    "data-type": "numeric",
                                    type: "number",
                                  },
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    sortable: true,
                                    label: "Сумма",
                                    type: "numeric",
                                    "data-type": "numeric",
                                    show: "soldData.totalSum",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            false
                              ? _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table-hover table-sm mt-1",
                                  },
                                  [
                                    _vm._m(0),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.getSortedDrugs(),
                                        function (drugId, index) {
                                          return _c("tr", [
                                            _c("td", [
                                              _vm._v(_vm._s(index + 1)),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [_vm._v(_vm._s(drugId))]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(_vm.drugs[drugId].title)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.drugsSoldData[drugId]
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("td"),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Продажи")]),
        _vm._v(" "),
        _c("th", [_vm._v("Склад")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }